<template>
  <div>
    <vx-card>
    <h3 class="mb-3">{{ $t('counseling_history') + ' [ ' + member.name + ' / ' + $t('mobile') + ' ' + member.mobile + ' / ' + $t('landline') + ' ' + member.landline + ' ]'}}</h3>
      <template slot="header">
      </template>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <select v-model="historySearchParams.result" class="vs-inputx vs-input--input normal md:mb-0">
            <option value="">{{ $t('all') }}</option>
            <option v-for="(option, key) in resultTypeOptions" :key="'result_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <select v-model="historySearchParams.search_type" class="vs-inputx vs-input--input normal md:mb-0">
            <option value="">{{ $t('all') }}</option>
            <option v-for="(option, key) in searchTypeOptions" :key="'search_type_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <vs-input :placeholder="$t('search')" v-model="historySearchParams.search" class="w-full"/>
        </div>
      </div>
      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadHistoryList(1)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>
    <vx-card id="consultationHistoryDataContainer" class="mb-8 vs-con-loading__container">
      <template slot="actions">
      </template>
      <vs-table hover-flat v-if="consultations && consultations.length" :data="consultations">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('in_out')"></vs-th>
          <vs-th v-text="$t('classification_consultation_result')"></vs-th>
          <vs-th v-text="$t('treatment_result')"></vs-th>
          <vs-th v-text="$t('join_now')"></vs-th>
          <vs-th v-text="$t('subscription_time')"></vs-th>
          <vs-th v-text="$t('consulting_title')"></vs-th>
          <vs-th v-text="$t('consultation_contents')"></vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.in_out"></vs-td>
            <vs-td v-text="tr.inquiry_name"></vs-td>
            <vs-td v-text="tr.treatment_result"></vs-td>
            <vs-td v-text="tr.join_now"></vs-td>
            <vs-td v-text="tr.subscription_time"></vs-td>
            <vs-td>
            <a href="#" v-text="$stringHelper.limitString(tr.title, 10)" @click.prevent="editConsultation(tr.member_id, tr.id)"></a>
            </vs-td>
            <vs-td>
            <a href="#" v-text="$stringHelper.limitString(tr.content, 10)" @click.prevent="editConsultation(tr.member_id, tr.id)"></a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template slot="footer">
        <paginate
        :total="historyPages"
        :click-handler="loadHistoryList"
        :value="initialPage"
        goto
        >
        </paginate>
      </template>
    </vx-card>
  </div>
</template>

<script>

import Consultation from '@/models/Consultation'
import Paginate from '@/mixins/paginate'
import Utils from '@/helpers/utils'

export default {
  name: 'Window.Consultation.History',
  mixins: [Paginate],
  data () {
    return {
      member_id: 0,
      historyPages: 1,
      initialPage: 1,
      historySearchParams: {
        member_id: typeof this.$route.query.member_id !== 'undefined' ? this.$route.query.member_id : '',
        result: typeof this.$route.query.result !== 'undefined' ? this.$route.query.result : '',
        search_type: typeof this.$route.query.search_type !== 'undefined' ? this.$route.query.search_type : '0',
        search: typeof this.$route.query.search !== 'undefined' ? this.$route.query.search : ''
      },
      consultations: {},
      member: {
        name: '',
        mobile: '',
        landline: ''
      },
      searchTypeOptions: [
        {
          label: this.$i18n.t('consulting_title'),
          value: '0'
        },
        {
          label: this.$i18n.t('consultation_contents'),
          value: '1'
        }
      ],
      resultTypeOptions: []
    }
  },
  mounted () {
    this.member_id = this.$route.params.id
    this.historySearchParams.member_id = this.member_id
    this.loadHistoryList(this.initialPage)
  },
  methods: {
    async loadHistoryList (page) {
      this.$vs.loading({container: '#consultationHistoryDataContainer'})

      const searchParams = this.historySearchParams
      searchParams['page'] = page

      this.$router.replace({ query: searchParams })
      const response = await Consultation.historyFindAll({ ...this.historySearchParams, page })
      this.member = response.data.meta.member
      this.consultations = response.data.data
      this.resultTypeOptions = response.data.meta.options.results
      this.historyPages = response.data.meta.pagination.last_page

      this.$vs.loading.close('#consultationHistoryDataContainer > .con-vs-loading')
    },
    editConsultation (memberId, consultationId) {
      Utils.openPopUp('window', 'edit-consultation', { id: memberId, consultationId })
    }
  }
}
</script>

<style scoped>

</style>
